import React from "react";
import { HelpCircle, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const SupportSection = () => {
    return (
        <section className="py-16 px-4 max-w-7xl mx-auto w-full">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="relative bg-neutral-900 rounded-[2rem] p-8 md:p-12 overflow-hidden shadow-2xl border border-neutral-800 flex flex-col md:flex-row items-center justify-between gap-10"
            >
                {/* Ambient Tech Glow Effects */}
                <div className="absolute top-0 right-0 w-72 h-72 bg-red-600 rounded-full mix-blend-screen filter blur-[100px] opacity-20 pointer-events-none translate-x-1/3 -translate-y-1/3"></div>
                <div className="absolute bottom-0 left-0 w-72 h-72 bg-yellow-500 rounded-full mix-blend-screen filter blur-[100px] opacity-10 pointer-events-none -translate-x-1/3 translate-y-1/3"></div>

                {/* Left Side: Content */}
                <div className="flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6 relative z-10 flex-1">
                    {/* Professional Icon Container */}
                    <div className="w-16 h-16 bg-neutral-800 border border-neutral-700 rounded-2xl flex items-center justify-center shrink-0 shadow-inner">
                        <HelpCircle size={32} className="text-yellow-500" />
                    </div>

                    <div>
                        <h2 className="text-xl md:text-2xl lg:text-3xl font-black text-yellow-400 mb-3 ">
                            Need Help Choosing a Course?
                        </h2>
                        <p className="text-gray-400 text-sm md:text-base font-medium max-w-xl leading-relaxed">
                            Not sure which program aligns with your exam
                            strategy? Our expert academic counselors are here to
                            map out your preparation journey.
                        </p>
                    </div>
                </div>

                {/* Right Side: Call to Action */}
                <div className="relative z-10 shrink-0 w-full md:w-auto">
                    <a
                        href="https://wa.me/918709364253"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center justify-center gap-3 bg-white text-neutral-900 px-8 py-4 rounded-xl font-black text-lg hover:bg-yellow-500 transition-all duration-300 shadow-[0_10px_20px_rgba(0,0,0,0.2)] hover:shadow-[0_15px_30px_rgba(234,179,8,0.3)] hover:-translate-y-1 w-full md:w-auto"
                    >
                        <span>Talk to an Expert</span>
                        <ArrowRight
                            size={20}
                            className="group-hover:translate-x-1.5 transition-transform duration-300"
                        />
                    </a>
                </div>
            </motion.div>
        </section>
    );
};

export default SupportSection;
